import React, { useRef, useEffect } from 'react';
import FontSettings from '../../../FontSettings/FontSettings';
import './TxtViewer.css';

export const TextDisplayContainer = ({
    children,
    fontSize,
    setFontSize,
    lineHeight,
    setLineHeight,
    displayFontSettings,
    className = '',
}) => {
    const scrollRef = useRef(null);

    useEffect(() => {
        if (scrollRef.current) {
            scrollRef.current.scrollTop = 0;
        }
    }, [children]);

    return (
        <>
            {displayFontSettings &&
                <div className="text-settings">
                    <FontSettings
                        fontSize={fontSize}
                        setFontSize={setFontSize}
                        lineHeight={lineHeight}
                        setLineHeight={setLineHeight}
                    />
                </div >}

            <div className="text-content-container">
                <div
                    className={`text-content-wrapper ${className}`}
                    ref={scrollRef}
                    style={{
                        fontSize: fontSize ? `${fontSize}px` : undefined,
                        lineHeight: lineHeight ? lineHeight : undefined,
                        whiteSpace: 'pre-wrap',
                        wordBreak: 'break-word',
                    }}
                >
                    {children}
                </div>
            </div>
        </>
    );
};